import apiClient from '../lib/apiClient';

const leaveService = {
  // Get all leave records with optional filters
  getLeaves: async (filters = {}) => {
    try {
      const result = await apiClient.get('/leaves', filters);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch leave records' };
    }
  },

  // Get leave by ID
  getLeave: async (leaveId) => {
    try {
      const result = await apiClient.get(`/leaves/${leaveId}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch leave record' };
    }
  },

  // Create new leave record
  createLeave: async (leaveData) => {
    try {
      const result = await apiClient.post('/leaves', leaveData);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to create leave record' };
    }
  },

  // Update leave record
  updateLeave: async (leaveId, updateData) => {
    try {
      const result = await apiClient.put(`/leaves/${leaveId}`, updateData);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update leave record' };
    }
  },

  // Delete leave record
  deleteLeave: async (leaveId) => {
    try {
      const result = await apiClient.delete(`/leaves/${leaveId}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to delete leave record' };
    }
  }
};

export default leaveService;

